(() => {
  /*
   * Modelle werden jetzt über Theme-Editor-Blöcke gepflegt (siehe
   * sections/five-models.liquid), nicht mehr über ein JS-Array.
   * Dieses Script kümmert sich nur noch um Slider-Verhalten,
   * Kreisnavigation und Tastatursteuerung.
   */

  function initialize(root) {
    if (root.dataset.sfReady === "true") return;
    root.dataset.sfReady = "true";

    const nav = root.querySelector(".sf-neos__nav");
    const track = root.querySelector(".sf-neos__track");
    if (!nav || !track) return;

    const cards = Array.from(track.children);
    const buttons = Array.from(nav.querySelectorAll(".sf-neos__jump"));
    if (!cards.length || !buttons.length) return;

    const sliderMode = window.matchMedia("(max-width: 1100px)");
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );

    let current = 0;
    let animationFrame;

    function select(index) {
      current = index;
      buttons.forEach((button, buttonIndex) => {
        button.setAttribute(
          "aria-pressed",
          String(buttonIndex === index)
        );
      });
    }

    function goToModel(index, showText = false) {
      select(index);

      const card = cards[index];
      const behavior = reducedMotion.matches ? "instant" : "smooth";

      if (!sliderMode.matches) return;

      track.scrollTo({
        left: card.offsetLeft - cards[0].offsetLeft,
        behavior
      });

      if (showText) {
        const title = card.querySelector(".sf-neos__title");
        const image = card.querySelector(".sf-neos__image-link");
        if (!title || !image) return;

        /* Etwa die untere Hälfte des Bilds bleibt sichtbar. */
        const imagePeek = Math.min(
          200,
          image.getBoundingClientRect().height / 2
        );

        const headerOffset = parseFloat(
          getComputedStyle(root).getPropertyValue("--sf-scroll-offset")
        ) || 24;

        window.scrollTo({
          top: Math.max(
            0,
            window.scrollY +
              title.getBoundingClientRect().top -
              imagePeek -
              headerOffset
          ),
          behavior
        });
      }
    }

    nav.addEventListener("click", (event) => {
      const button = event.target.closest(".sf-neos__jump");
      if (!button) return;

      goToModel(Number(button.dataset.index), true);
    });

    track.addEventListener("scroll", () => {
      cancelAnimationFrame(animationFrame);

      animationFrame = requestAnimationFrame(() => {
        if (!sliderMode.matches) return;

        let nearest = 0;
        let smallestDistance = Infinity;

        cards.forEach((card, index) => {
          const distance = Math.abs(
            card.offsetLeft -
            cards[0].offsetLeft -
            track.scrollLeft
          );

          if (distance < smallestDistance) {
            smallestDistance = distance;
            nearest = index;
          }
        });

        select(nearest);
      });
    }, { passive: true });

    track.addEventListener("keydown", (event) => {
      if (event.target !== track || !sliderMode.matches) return;

      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault();

        const direction = event.key === "ArrowRight" ? 1 : -1;
        const next = Math.max(
          0,
          Math.min(cards.length - 1, current + direction)
        );

        goToModel(next);
      }
    });

    sliderMode.addEventListener("change", () => {
      track.scrollLeft = 0;
      select(0);
    });

    select(0);
  }

  function initializeAll(container) {
    if (container.matches?.("[data-sf-neos]")) {
      initialize(container);
    }

    container.querySelectorAll("[data-sf-neos]").forEach(initialize);
  }

  initializeAll(document);

  /* Erneute Initialisierung im Shopify Theme-Editor bei Section-Reload. */
  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
